import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" -- ");
import Negotiation from "@/modules/diplomacy/components/Negotiation.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerContractNegotiation',
  props: {
    negotiation: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Negotiation, _mergeProps(_ctx.$props, {
        negotation: __props.negotiation
      }), {
        "target-title": _withCtx(() => [_createVNode(EntityLink, {
          entity: __props.negotiation.target
        }, null, 8, ["entity"])]),
        "after-balance": _withCtx(() => [_createVNode(FormGroup, {
          label: _ctx.$t('current_contract'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(__props.negotiation.target.contractYears, 'years').humanize()), 1)]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('team_target'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(__props.negotiation.years, 'years').humanize()), 1)]),
          _: 1
        }, 8, ["label"]), _ctx.$debug ? (_openBlock(), _createBlock(FormGroup, {
          key: 0,
          label: _ctx.$t('player_target'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(__props.negotiation.playerTargetYears, 'years').humanize()), 1)]),
          _: 1
        }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(FormGroup, {
          label: _ctx.$t('negotiated_duration'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [__props.negotiation.negotiationCurrentYears < 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_1], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(_ctx.$duration(__props.negotiation.negotiationCurrentYears, 'years').humanize()), 1)], 64))]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 16, ["negotation"]);
    };
  }
});